module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.gameFinished) ? _c('js-logo') : _vm._e(), _vm._v(" "), (!_vm.gameFinished) ? _c('ui-options', {
    on: {
      "answer": _vm.answer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gameFinished) ? _c('result-page') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7becf9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 150
// module chunks = 1